import Box from "@mui/material/Box";

export default function ColorDot({ color }: { color: string }) {
  return (
    <Box
      component="span"
      sx={{ width: 12, height: 12, borderRadius: "50%", bgcolor: color, flexShrink: 0, mr: 1.5, display: "inline-block" }}
    />
  );
}
